// src/components/BottomToTop.jsx
import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function BottomToTop() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 250);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
      className={`
        fixed bottom-[88px] right-5 z-[999]
        flex h-11 w-11 items-center justify-center
        rounded-full
        border border-cyan-400/30
        bg-[#041426]
        text-cyan-400
        shadow-lg shadow-black/30
        transition-all duration-300
        hover:-translate-y-1
        hover:border-cyan-400
        hover:bg-cyan-400
        hover:text-[#020b18]
        sm:right-7
        ${
          showButton
            ? "translate-y-0 scale-100 opacity-100"
            : "pointer-events-none translate-y-4 scale-90 opacity-0"
        }
      `}
    >
      <FaArrowUp className="text-xs" />
    </button>
  );
}